import {Player} from './project-player';
import {PageResponse} from '../pageResponse';
import {PageRequest} from '../pageRequest';
import {Transaction} from './transaction';

export interface Telemetry {
  id: string;
  transaction: Transaction;
  player?: Player;
  eventId: number;
  event: string;
  eventType: string;
  creationDate: string;
  description?: string;
  customerData?: CustomerData;
}

export class TelemetryResponse extends PageResponse {
  content: Telemetry[];
}

export class TelemetryByPlayerPageRequest extends PageRequest {
  projectId?: string;
  playerId?: string;
  event?: string;
}

export class TelemetryByProjectPageRequest extends PageRequest {
  projectId?: string;
  event?: string;
}

export class CustomerData {
  id: string;
  data: string;
}
